import InsertVariableDropdown from './InsertVariableDropdown';

export default InsertVariableDropdown;
